// :cow: Cosmose CONFIDENTIAL :iso:
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { GroupsResponse } from '@coa/app/shared/add-to-group-dialog/modules/add-to-group/models/groups.response';
import {
  selectGroups,
  selectShowEmpty,
  selectShowError,
  selectShowList,
  selectShowSkeleton,
} from '@coa/app/shared/add-to-group-dialog/modules/add-to-group/store/add-to-group.selectors';

@Component({
  selector: 'coa-add-to-group-body',
  templateUrl: './add-to-group-body.component.html',
  styleUrls: ['./add-to-group-body.component.scss'],
})
export class AddToGroupBodyComponent {
  @Input() clientId: number;
  @Input() selections: number[];
  @Output() showCreateGroup = new EventEmitter<void>();

  showEmpty$: Observable<boolean> = this.store$.pipe(select(selectShowEmpty));
  showList$: Observable<boolean> = this.store$.pipe(select(selectShowList));
  showSkeleton$: Observable<boolean> = this.store$.pipe(select(selectShowSkeleton));
  showError$: Observable<boolean> = this.store$.pipe(select(selectShowError));

  groups$: Observable<GroupsResponse> = this.store$.pipe(select(selectGroups));

  constructor(
    private store$: Store,
  ) {
  }
}
